export default __webpack_public_path__ + "static/media/ogc-construction-black.2eb37083.svg";